import { render } from "./ChangeAddressStatusView.vue?vue&type=template&id=1dc6f9bb&scoped=true"
import script from "./ChangeAddressStatusView.vue?vue&type=script&lang=js"
export * from "./ChangeAddressStatusView.vue?vue&type=script&lang=js"

import "./ChangeAddressStatusView.vue?vue&type=style&index=0&id=1dc6f9bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc6f9bb"]])

export default __exports__